module.exports = __webpack_public_path__ + "summernote.608fd10666a860567740.woff";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/summernote/dist/font/summernote.woff?0d0d5fac99cc8774d89eb08b1a8323c4
// module id = ../../../../summernote/dist/font/summernote.woff?0d0d5fac99cc8774d89eb08b1a8323c4
// module chunks = styles